import { combineReducers } from 'redux';
import adminReducer from './Admin.reducer';
import filesReducer from './Files.reducer';
import masterReducer from './Master.reducer';
import doctorReducer from './Doctor.reducer';
import imageReducer from './Images.reducer';
import settingreducer from './Setting.reducer';
import superAdminReducer from './SuperAdmin.reducer';
import PlanReducer from './Plan.reducer';
import ExtraAdminReducer from './ExtraAdmin.reducer';
import FormFieldsReducer from './Formfields.reducer';

const rootReducers = combineReducers({
    admin: adminReducer,
    files: filesReducer,
    master: masterReducer,
    doctor: doctorReducer,
    image: imageReducer,
    setting: settingreducer,
    superAdmin: superAdminReducer,
    plan: PlanReducer,
    extraAdmin: ExtraAdminReducer,
    formFields: FormFieldsReducer,
})

export default rootReducers;